// src/components/Dashboard/PerformanceCard.js
import React from "react";

export default function PerformanceCard({ data }) {
    if (!data?.success) return null;

    const { cpu, memoryMB, uptime, threads } = data;

    return (
        <div className="bg-white rounded-2xl p-5 shadow-md border border-orange-300 hover:shadow-orange-400/40 transition-all duration-300">
            <h2 className="text-lg font-semibold mb-3 text-orange-600">Performance Snapshot</h2>
            <div className="space-y-2 text-sm text-gray-700">
                <p>🧩 CPU Usage: <span className="text-orange-500 font-semibold">{cpu}%</span></p>
                <p>💾 Memory Used: <span className="text-orange-500 font-semibold">{memoryMB} MB</span></p>
                <p>⏱️ Uptime: <span className="text-orange-500 font-semibold">{uptime}</span></p>
                <p>🧵 Threads: <span className="text-orange-500 font-semibold">{threads}</span></p>
            </div>
        </div>
    );
}
